var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M16 8.66667C12.68 8.66667 10.6667 11.36 10.6667 14.6667V22.6667H21.3333V14.6667C21.3333 11.36 19.32 8.66667 16 8.66667Z",
    fill: "#323232"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 29.3333C17.4667 29.3333 18.6667 28.1333 18.6667 26.6667H13.3333C13.3333 28.1333 14.5333 29.3333 16 29.3333ZM24 14.6667C24 10.5733 21.8267 7.14666 18 6.23999V5.33333C18 4.22666 17.1067 3.33333 16 3.33333C14.8933 3.33333 14 4.22666 14 5.33333V6.23999C10.1867 7.14666 8 10.56 8 14.6667V21.3333L5.33333 24V25.3333H26.6667V24L24 21.3333V14.6667ZM21.3333 22.6667H10.6667V14.6667C10.6667 11.36 12.68 8.66666 16 8.66666C19.32 8.66666 21.3333 11.36 21.3333 14.6667V22.6667ZM10.1067 5.43999L8.2 3.53333C5 5.97333 2.89333 9.73333 2.70667 14H5.37333C5.57333 10.4667 7.38666 7.37333 10.1067 5.43999ZM26.6267 14H29.2933C29.0933 9.73333 26.9867 5.97333 23.8 3.53333L21.9067 5.43999C24.6 7.37333 26.4267 10.4667 26.6267 14Z",
    fill: "#323232"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.3f65726e56dd9c3fa34396cd5c818405.svg";
export { ForwardRef as ReactComponent };